(function () {
    "use strict";

    function ViewerController(viewerService, TYPEVIEWERS) {

        var vm = this;
        vm.typeViewer = TYPEVIEWERS.noviewer;
        vm.typesViewerApp = TYPEVIEWERS;
        vm.isOffice = false;
        vm.isMail = false;
        vm.isGd = false;
        vm.isNoViewer = false;

        vm.$onChanges = function (changes) {

            vm.isOffice = false;
            vm.isMail = false;
            vm.isGd = false;
            vm.isNoViewer = false;

            vm.extension = !changes.extension ? null : changes.extension.currentValue;
            vm.idContainer = !changes.idContainer ? null : changes.idContainer.currentValue;
            vm.idDocument = !changes.idDocument ? null : changes.idDocument.currentValue;
            vm.idFolder = !changes.idFolder ? null : changes.idFolder.currentValue;
            vm.isFilecontainer = !changes.isFilecontainer ? null : changes.isFilecontainer.currentValue;
            loadTypeViewerByExtension();
        };

        function loadTypeViewerByExtension() {
            if (vm.extension) {
                var extensionNoPoint = vm.extension.replace(".", "");
                viewerService.associatedViewer.get({ extension: extensionNoPoint },
                    function (data) {
                        console.log(data);
                        vm.typeViewer = data.type;
                        loadTypeViewer();
                    },
                    function (error) {
                        console.log(error);
                        vm.typeViewer = TYPEVIEWERS.noviewer;
                        loadTypeViewer();
                    }
                );
            } else {
                vm.typeViewer = TYPEVIEWERS.noviewer;
                loadTypeViewer();
            }

        }

        function loadTypeViewer() {
            vm.isOffice = vm.typeViewer === TYPEVIEWERS.office;
            vm.isMail = vm.typeViewer === TYPEVIEWERS.email;
            vm.isGd = vm.typeViewer === TYPEVIEWERS.gd;
            vm.isNoViewer = vm.typeViewer === TYPEVIEWERS.noviewer;

            if (vm.onTypeviewer) {
                var canFullScreen = vm.isOffice;
                vm.onTypeviewer({ canFullScreen: canFullScreen });
            }
        }

        vm.loadedFile = function () {
            if (vm.onLoaded) {
                vm.onLoaded();
            }
        };
    }

    ViewerController.$inject = ['solpheo.viewerService', 'TYPEVIEWERS'];

    angular.module("sphforms.main")
        .component('solpheoViewer', {
            templateUrl: 'modules/main/components/viewer/components/viewer.template.html',
            controller: ViewerController,
            bindings: {
                idContainer: '<',
                idDocument: '<',
                idFolder: '<',
                isFilecontainer: '<',
                extension: '<',
                isDrive: '<',
                idDriveProvider: '<',
                idDrive: '<',
                onTypeviewer: "&",
                onLoaded: "&",
                enableprint: '<',
                getPageRotations: '<'
            }
        });

}());